import "./App.css";
import { Route, Routes, BrowserRouter } from "react-router-dom";
import Home from "./Components/Home";
import AskExpert from "./Components/AskExpert";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/allpackages" element={<Home />} />
          <Route path="/ask-expert" element={<AskExpert />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
